import { setStoreValue } from "@/store/utils";

export const SET_IS_FETCHING_ORGANISATION_MESSAGE_TEMPLATES =
  "SET_IS_FETCHING_ORGANISATION_MESSAGE_TEMPLATES";
export const SET_ORGANISATION_MESSAGE_TEMPLATES =
  "SET_ORGANISATION_MESSAGE_TEMPLATES";
export const SET_IS_ADDING_ORGANISATION_MESSAGE_TEMPLATE =
  "SET_IS_ADDING_ORGANISATION_MESSAGE_TEMPLATE";
export const SET_IS_EDITING_ORGANISATION_MESSAGE_TEMPLATE =
  "SET_IS_EDITING_ORGANISATION_MESSAGE_TEMPLATE";

const mutations = {
  [SET_IS_FETCHING_ORGANISATION_MESSAGE_TEMPLATES]: setStoreValue(
    "isFetchingOrganisationMessageTemplates"
  ),
  [SET_ORGANISATION_MESSAGE_TEMPLATES]: setStoreValue(
    "organisationMessageTemplates"
  ),
  [SET_IS_ADDING_ORGANISATION_MESSAGE_TEMPLATE]: setStoreValue(
    "isAddingOrganisationMessageTemplate"
  ),
  [SET_IS_EDITING_ORGANISATION_MESSAGE_TEMPLATE]: setStoreValue(
    "isEditingOrganisationMessageTemplate"
  )
};

const state = {
  organisationMessageTemplates: [],
  isFetchingOrganisationMessageTemplates: false,
  isAddingOrganisationMessageTemplate: false,
  isEditingOrganisationMessageTemplate: false
};

export { mutations, state };
